import { createAction, props } from '@ngrx/store';

export const closeNotificationBar = createAction('[LAYOUT] Close notification bar');
export const closeTicker = createAction('[LAYOUT] Close ticker');
export const closeRatioWarningDialog = createAction('[LAYOUT] Close ratio dialog');

export const showRatioWarningDialog = createAction('[LAYOUT] show ratio dialog', props<{ scale: number }>());
